import { render, staticRenderFns } from "./CommunityFaq.vue?vue&type=template&id=4436410c&scoped=true"
import script from "./CommunityFaq.vue?vue&type=script&lang=js"
export * from "./CommunityFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4436410c",
  null
  
)

export default component.exports